import React from "react";
import RestRequest from "../../tool/RestRequest";
import config from "../../config";
import FavoriteService from "../../service/FavoriteService";

function RemoveWishlist({product_id}) {


    let clock = (e) => {
        RestRequest.delete(config.restFavorite, product_id).then(data => {
            if (data.status === 200) {
                let _del = document.getElementById(`wl-${product_id}`);

                if (_del) {
                    _del.remove();
                    FavoriteService.updateCounter(true);
                }
            }
        });
    };

    return <div className="remove-wishlist" onClick={clock}>
        <img className="remove-wishlist-icon" src="/assets/images/icons/white-remove.svg"/>
    </div>
}

export default RemoveWishlist;